// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5fcaa10f","239":"2e7d3504","455":"20d47155"}[chunkId] + ".chunk.js";
};